import { useState, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { useParams, Link } from 'react-router-dom';

import { MiniTable } from '@rr/ui';
import { GET_TEACHER_LESSONS_QUERY } from './GetTeacherLessons.query.gql';
import { GetTeacherLessonsQuery } from 'types/graphql';
import { humanDate } from '@rr/utils';

export const TeacherLessons = () => {
  const { userId: teacherId }: { userId: string } = useParams();
  const [offset, setOffset] = useState(0);
  const LIMIT = 5;

  useEffect(() => {
    setOffset(0);
  }, [teacherId]);

  const updateOffset = (number: number) => setOffset(number);

  const { loading, error, data } = useQuery<GetTeacherLessonsQuery>(
    GET_TEACHER_LESSONS_QUERY,
    {
      variables: {
        uid: teacherId,
        offset,
        limit: LIMIT,
      },
    }
  );

  if (error) {
    console.error(error);
    return <div>Error</div>;
  }

  if (loading) {
    return <div>Loading...</div>;
  }

  const LESSON_COLUMNS = [
    {
      Header: 'Date',
      accessor: 'date',
    },
    {
      Header: 'Time',
      accessor: 'start_time',
      // @ts-expect-error dumb
      Cell: ({ value, cell }) => {
        return (
          <>
            {value} - {cell.row.original.end_time}
          </>
        );
      },
    },
    {
      Header: 'Status',
      accessor: 'status',
    },
    {
      Header: 'Student',
      accessor: 'student',
      // @ts-expect-error dumb
      Cell: ({ value, cell }) => (
        <Link to={`/students/${cell.row.original.id}`}>{value}</Link>
      ),
    },
    {
      Header: 'Location',
      accessor: 'location',
    },
  ];

  const lessonData =
    data?.users_by_pk?.lessons.map((lesson) => ({
      student: lesson.student.gdpr_name,
      id: lesson.student.id,
      location: lesson.location?.name,
      date: humanDate(lesson.start_time),
      status: lesson.status,
      start_time: humanDate(lesson.start_time, {
        minute: '2-digit',
        hour: '2-digit',
        hour12: true,
      }),
      end_time: humanDate(lesson.end_time, {
        minute: '2-digit',
        hour: '2-digit',
        hour12: true,
      }),
    })) || [];

  return lessonData.length !== 0 ? (
    <MiniTable.Wrapper
      columns={LESSON_COLUMNS}
      data={lessonData}
      offset={offset}
      count={data?.users_by_pk?.lessons_aggregate.aggregate?.count}
      limit={LIMIT}
      updateOffset={updateOffset}
    >
      <MiniTable.Header />
      <MiniTable.Body />
      <MiniTable.Pagination />
    </MiniTable.Wrapper>
  ) : (
    <MiniTable.Zero>No Lessons</MiniTable.Zero>
  );
};
